module.exports = __webpack_public_path__ + "img/3.7b22d597.png";